import type { ElementType } from 'react';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import SmsIcon from '@mui/icons-material/Sms';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import LocalPostOfficeIcon from '@mui/icons-material/LocalPostOffice';
import type { ChannelType } from './CampaignDefinitionStep';

type Channel = Exclude<ChannelType, ''>;

export const CHANNEL_OPTIONS: ReadonlyArray<{ value: Channel; label: string; Icon: ElementType }> = [
  { value: 'courrier', label: 'Courrier', Icon: LocalPostOfficeIcon },
  { value: 'email', label: 'Email', Icon: AlternateEmailIcon },
  { value: 'sms', label: 'SMS', Icon: SmsIcon },
  { value: 'wallet', label: 'Wallet', Icon: AccountBalanceWalletIcon },
  { value: 'cashdesk', label: 'Caisse', Icon: PointOfSaleIcon },
];

export const CHANNEL_LABELS: Record<Channel, string> = Object.fromEntries(
  CHANNEL_OPTIONS.map(({ value, label }) => [value, label]),
) as Record<Channel, string>;

export const CHANNEL_ID: Record<ChannelType, number> = {
  courrier: 1, email: 2, sms: 4, cashdesk: 8, wallet: 9, '': 0,
};

export const CHANNEL_BY_ID: Record<number, Channel> = {
  1: 'courrier', 2: 'email', 4: 'sms', 8: 'cashdesk', 9: 'wallet',
};
